var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
* Version 3 migrations for the website. Cleanup migration.
* - Remove unused schemaVersion property from website.
* - Remove deprecated version property from website (replaced with frameworkVersion)
*/
export default function v1(website) {
    var newWebsite = __assign(__assign({}, website), { frameworkVersion: 3 });
    if (newWebsite.schemaVersion) {
        delete newWebsite.schemaVersion;
    }
    if (newWebsite.version) {
        delete newWebsite.version;
    }
    return newWebsite;
}
